import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { authSelector } from '@/stores/auth/authSlice'
import { Outlet, Navigate } from 'react-router-dom'

const PublicRouteMiddleware = () => {
  const { isAuthenticated } = useSelector(authSelector)
  const params = new URLSearchParams(location.search)

  if (isAuthenticated) {
    const redirectPath = params.get('redirect') || '/home'
    // console.log('redirectPath:', params.get('redirect'))

    return <Navigate to={redirectPath} replace />
  }

  return (
    <div>
      <Outlet />
    </div>
  )
}

export default PublicRouteMiddleware
